import { render, staticRenderFns } from "./groupGoodsItem.vue?vue&type=template&id=ad478314&"
import script from "./groupGoodsItem.vue?vue&type=script&lang=js&"
export * from "./groupGoodsItem.vue?vue&type=script&lang=js&"
import style0 from "./groupGoodsItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports